export const defaultStyle = {
  ContentContainer: "md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto p-[15px] lg:pt-[45px] ",

  Container:
    " text-green font-Light text-[36px] lg:text-[60px] mb-[60px]  tracking-normal leading-1.2 px-[15px] font-thin mt-0 w-100%",

  Heading: "md:flex block  ",

  Content:
    "md:border-r-1 md:border-gray-400 h-73 md:last:border-none mb-[60px] w-100% relative md:px-[15px] lg:first:pr-[50px] lg:px-[50px] md:first:px-0 box-border w-100%",

  Content2:
    "text-[10px] md:text-[14px]  mb-[30px] font-Regular font-bold font-stretch tracking-[0.35px] md:mb-[44px] mt-[0px] hover:text-red-700 hover:underline w-100%",

  Para2:
    " md:text-[21px] w-[150px] h-[192px] text-[14px] hover:text-orange-700 hover:underline font-Regular w-100% ",
  Para3:
    " md:text-[21px] text-[14px] hover:text-orange-700 hover:underline font-Regular w-100% ",

  Button: "flex flex-col items-center justify-center pb-[30px]",

  Button2:
    "font-bold mt-[60px] text-[21px] text-center cursor-pointer uppercase font-Regular bg-purple border-2 border-purple rounded-40 px-[45px]  py-[14px]  box-border text-white hover:opacity-[70%]",
  HeadingFour: "flex",
  HeadingOne: " h-[243px] ",
}

export const SCROLL_TEXT = {
  Heading:
    "md:flex block  pressReleaseTitle md:pl-[15px] md:ml-[0px] lg:ml-0 mb-[70px] md:mb-[90px]  ",
  ContentContainer: "md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto  pt-[90px] lg:pl-[15px] ",

  Container:
    " text-green font-Light md:text-[60px] md:mb-[80px]  text-[36px] lg:text-[60px] mb-[60px]  tracking-normal leading-[1.2] px-[35px] lg:px-[0px] font-light  mt-0 md:px-[15px]",

  Content:
    "md:border-r-1 md:border-gray-400 h-73 md:last:border-none w-full relative md:first:pr-[50px] md:px-[20px] lg:px-[50px] md:first:px-0   box-border",

  Content2:
    "text-[10px] md:text-[14px]  mb-[30px] font-Regular font-bold font-stretch tracking-[0.35px] md:mb-[44px] mt-[0px]",

  Para2:
    " md:text-[21px] w-[150px] h-[147px] mb-[25px] text-[14px] hover:text-orange hover:underline font-Regular ",
  Para3:
    " md:text-[21px] text-[14px] hover:text-orange hover:underline font-Regular ",

  Button:
    "flex flex-wrap box-border justify-center  w-full mb-[30px] md:mb-[45px]  ",

  Button2:
    " bg-purple  border-2 border-purple text-white inline-block px-[45px] py-[20px]  rounded-40 uppercase text-center text-[21px] leading-[21px] tracking-[2.2px] font-Regular font-bold box-border cursor-pointer  font-bold text-[21px] text-center cursor-pointer w-[180px] h-[65px] hover:opacity-[70%]",
  HeadingFour: "flex",
  HeadingOne: "",
}
export const RECENT_NEWS = {
  ...defaultStyle,
  Container:
    "text-purple font-MDLZBiteType mb-[60px] md:mb-[80px] md:leading-[72px] leading-[43.2px]  tracking-normal text-[36px] md:text-[60px]",
  Para3:
    " md:text-[21px] text-[14px] hover:text-orange-700 hover:underline hover:text-red-700 font-Regular font-stretch w-100% text-purple",
  Content:
    "md:border-r-1 md:border-gray-400 h-73 md:last:border-none mb-[60px] w-100% relative md:px-[15px] lg:first:pr-[70px] lg:px-[50px] md:first:px-0 box-border w-[25%]",
  Content2:
    "text-[10px] md:text-[14px]  mb-[30px] font-Regular font-bold font-stretch tracking-[0.35px] md:mb-[44px] mt-[0px] hover:text-red-700 hover:underline w-100% text-purple",
}
